module.exports = __webpack_public_path__ + "static/media/071.a4c38c4f.jpg";